import {Http, Response, Headers} from '@angular/http';
import {NotificationsService} from 'angular2-notifications';
import Broadcaster from '../broadcaster.service';
import EVENTS from '../../enums/events.enum';
import {Observable} from "rxjs/Rx";
import CypherService from "../cypher.service";

class DataProvider {


    constructor(protected http: Http,
                protected Broadcaster: Broadcaster,
                protected NotificationsService: NotificationsService,
                protected cypherService: CypherService) {
    }

    public preventDefaultError: boolean = false;
    // mock API
    // protected baseUri = 'http://private-f10a50-mobienext.apiary-mock.com/';

    // dev API
    // protected baseUri = 'http://10.0.0.4:8086/api/';

    // prod API
    protected baseUri = 'http://13.126.134.148/api/';

    protected loader(enable: boolean) {
        this.Broadcaster.emit({
            event: EVENTS.LOADER,
            message: {
                isEnabled: enable
            }
        });
    }

    protected map = (response: any) => {
        this.loader(false);
        if (response.headers.get('content-type').match('application/json')) {
            return response.json();
        } else {
            return response.text();
        }
    }

    protected catch = (errorResponse: Response, caught: Observable<any>) => {
        if (!this.preventDefaultError && errorResponse.status !== 404) {
            this.NotificationsService.error("Server error!", "An unexpected error has occurred while contacting our servers.");
            this.preventDefaultError = false;
        }
        this.loader(false);
        return Observable.throw(errorResponse);
    }

    private getEncryptedHeaders(encryptionParams) {
        let toEncrypt = {
            search: "",
            payload: ""
        }
        if (encryptionParams.search) {
            toEncrypt.search = '?' + encryptionParams.search;
        }
        if (encryptionParams.body) {
            for (let key in encryptionParams.body) {
                toEncrypt.payload += '|' + key + ':' + encryptionParams.body[key];
            }
        }
        let encoded = this.cypherService.encrypt(encryptionParams.url + toEncrypt.search + toEncrypt.payload);
        let headers = new Headers();
        headers.append('key', encoded);
        return headers;
    }

    public post(url: string, body, options): Observable<any> {
        this.loader(true);
        options.headers = this.getEncryptedHeaders({
            url: url,
            search: options.search,
            body: body
        });
        console.log('decrypted', this.cypherService.decrypt(options.headers.get('key')));
        return this.http.post(url, body, options)
            .map(this.map)
            .catch(this.catch)
    }

    public get(url: string, options): Observable<any> {
        options.headers = this.getEncryptedHeaders({
            url: url,
            search: options.search
        });
        console.log('decrypted', this.cypherService.decrypt(options.headers.get('key')));
        this.loader(true);
        return this.http.get(url, options)
            .map(this.map)
            .catch(this.catch)
    }
}

export default DataProvider;



// WEBPACK FOOTER //
// ./src/app/services/dataProviders/dataProvider.service.ts